import { PagedResultsModelSystemResponse } from '@kcftech/prometheustypescriptapiclient';
import { QueryObserverOptions, useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

export type UseSystems = Readonly<{
    /**
     * Filter statements to narrow results by properties.
     */
    filter?: string;
    /**
     * Which results page to fetch.
     */
    page?: number;
    /**
     * Number of results per page.
     */
    pageLimit?: number;
    /**
     * Sort statements to sort results by multiple properties.
     */
    orderBy?: string;
    /**
     * Search term to narrow results.
     */
    nameSearch?: string;
}>;

/**
 * Fetches a paged list of systems that the current user has access to.
 */
export function useSystems(
    { filter, page, pageLimit, orderBy, nameSearch }: UseSystems,
    options?: QueryObserverOptions<PagedResultsModelSystemResponse>
) {
    return useQuery({
        queryKey: ['get-systems', filter, page, pageLimit, orderBy, nameSearch],
        queryFn: () =>
            sdClient.getSystems({ filter, page, pageLimit, orderBy, nameSearch }),
        ...options,
    });
}
